import { Instance } from 'mobx-state-tree';
import { DriverAssignInfoDtoModelBase } from './DriverAssignInfoDtoModel.base';

/* The TypeScript type of an instance of DriverAssignInfoDtoModel */
export interface DriverAssignInfoDtoModelType extends Instance<typeof DriverAssignInfoDtoModel.Type> {}

/* A graphql query fragment builders for DriverAssignInfoDtoModel */
export { selectFromDriverAssignInfoDto, driverAssignInfoDtoModelPrimitives, DriverAssignInfoDtoModelSelector } from './DriverAssignInfoDtoModel.base';

/**
 * DriverAssignInfoDtoModel
 */
export const DriverAssignInfoDtoModel = DriverAssignInfoDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
